<template>
  <div class="step-one">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-loading="loading" element-loading-text="加载中">
      <el-form-item label="账号" prop="userName">
        <el-input v-model.number="ruleForm.userName" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="请再次输入密码"></el-input>
      </el-form-item>
      <div style="text-align: center">
         <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
      </div>
      <el-form-item v-if="this.disclaimerExitsData">
        <el-checkbox v-model="checked"></el-checkbox><span style="color:rgb(255, 47, 47);margin-left:5px;">已阅读并同意<i @click="dialogVisible =  true" style="color:#fff;font-style: normal;cursor: pointer">{{text}}</i></span>
      </el-form-item>
      <el-dialog
        title="免责申明"
        :center="true"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <p v-html="disclaimerData"></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-form>
  </div>

</template>

<script>
import { disclaimerExits, getDisclaimerByAssoId, checkAccount } from '@/api/association'
import md5 from 'js-md5'
export default {
  name: 'StepOne',
  components: {
  },
  data () {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系方式'))
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的电话'))
        }
      }
    }

    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      text: '<<免责申明>>',
      checked: false,
      radio: '1',
      num1: 0,
      loading: false,
      disclaimerExitsData: undefined,
      disclaimerData: undefined,
      ruleForm: {
        pass: '',
        checkPass: '',
        userName: ''
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        userName: [
          { validator: phoneRules, trigger: 'blur' }
        ]
      },
      // parameter: {
      //   phoneNo: userName,
      //   assoId: localStorage.getItem('assoId')
      // },
      fileList: [],
      bg1: {
        backgroundImage: 'url(/static/images/login-bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0px 0px',
        backgroundSize: '100% 100%'
      },
      assoInfo: JSON.parse(localStorage.getItem('assoInfo')),
      isActive: '0'

    }
  },
  methods: {
    disclaimerExits () {
      disclaimerExits(localStorage.getItem('assoId')).then(res => {
        if (res.data.status === 0) {
          if (res.data.data) {
            this.disclaimerExitsData = res.data.data
            this.getDisclaimerByAssoId()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getDisclaimerByAssoId () {
      getDisclaimerByAssoId(localStorage.getItem('assoId')).then(res => {
        if (res.data.status === 0) {
          console.log(res.data)
          this.disclaimerData = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 登录
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.disclaimerExitsData && !this.checked) {
            this.$message.error('请阅读并同意《免责申明》')
            return false
          }
          this.checkAccount()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    checkAccount () {
      this.loading = true
      let parameter = {
        phoneNo: this.ruleForm.userName,
        assoId: localStorage.getItem('assoId')
      }
      checkAccount(parameter).then(res => {
        this.loading = false
        let applyInfo = {
          phoneNo: this.ruleForm.userName,
          pass: md5(this.ruleForm.pass)
        }
        if (res.data.status === 0) {
          localStorage.setItem('applyInfo', JSON.stringify(applyInfo))
          this.$message.success('账号可用,请填写会员信息')
          this.$emit('getStep', '2')
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('网络错误')
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },

    // 注册
    resignForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改密码
    updataForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  mounted () {

  },
  created () {
    this.disclaimerExits()
    // this.bg1.height = this.getHeight() + 'px'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .step-one  /deep/ .el-form-item__label{
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/components/register/components/stepOne.vue